import { start } from "repl";
import EventManager from "../../../../manager/event_manager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class ChatEmoji extends cc.Component {

    EmojiNodeList:cc.Node[] = []
    TargetPlayCount = 5 //播放次数
    CurPlayCount = 0 //当前已经播了几次

    CurEmojiIndex = 0 //当前图标的索引
    IntervalTime = 0.2 //每隔多久换一张图片
    TotalTime = 0  //累计时间
    IsPlaying = false
    
    start(){
        //EventManager.instance.off("StopPlayEmoji", this.StopPlayEmoji)
        EventManager.instance.on("StopPlayEmoji", this.StopPlayEmoji, this, true)
    }

    onDestroy() {
        //EventManager.instance.off("StopPlayEmoji", this.StopPlayEmoji)
    }

    update (dt) {
        if(this.IsPlaying) {
            this.TotalTime += dt
            if(this.TotalTime >= this.IntervalTime) {
                //换一张图片
                this.TotalTime = 0
                this.CurEmojiIndex++
                this.SetCurEmoji()
            }
        }
    }

    IsInit = false
    Init () {
        if(!this.IsInit && this.EmojiNodeList.length <= 0){
            for (let i = 0; i < this.node.childrenCount; i++) {
                let childNodeName = "expression" + this.node.name + "_0" + (i + 1)//expression1_01
                let childNode = this.node.getChildByName(childNodeName)
                childNode.active = false
                this.EmojiNodeList[i] = childNode
            }
            if(this.EmojiNodeList.length <= 2) {
                this.TargetPlayCount = 10
            }else if(this.EmojiNodeList.length <= 3) {
                this.TargetPlayCount = 7
            }
            this.IsInit = true
        }
    }

    StartPlayEmoji(){
        this.Init()
        this.CurEmojiIndex = 0
        this.CurPlayCount = 0
        this.IsPlaying = true
        if(this.EmojiNodeList.length > 0){
            this.node.active = true
        }
    }

    SetCurEmoji(){
        if(this.CurEmojiIndex >= this.EmojiNodeList.length) {
            this.CurEmojiIndex = 0
            this.CurPlayCount++
            if(this.CurPlayCount >= this.TargetPlayCount){
                this.StopPlayEmoji()
                return
            }
        }
        for (let i = 0; i < this.EmojiNodeList.length; i++) {
            this.EmojiNodeList[i].active = this.CurEmojiIndex == i
        }
    }

    StopPlayEmoji(){
        if(this.node && this.node.isValid){
            this.IsPlaying = false
            this.node.active = false
            this.CurEmojiIndex = 0
            this.CurPlayCount = 0
        }
    }
}